import "./browserCompatibility";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import authStore from "./utils/authStorage";
import "./styles/index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Restore/clear stored authentication before any protected route renders.
authStore.processPendingLogoutOnLoad();
authStore.ensureTabSession();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
